var map = {
	"./chumbak.svg": 16785,
	"./coindcx.svg": 55341,
	"./dream11.svg": 98183,
	"./fisdom.svg": 69411,
	"./jumbotail.svg": 67051,
	"./kubric.svg": 51649,
	"./rentomojo.svg": 21987,
	"./snapdeal.svg": 5961,
	"./yulu.svg": 41955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4636;